module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-Regular.0dfe9fea.ttf";